import {tracking as barkTrackingLogEvent, _t} from "@bark/bark-core";
import ReviewStars from "../review-stars";

export default function SelectRatingsFilter(){

	const { Handlebars } = window;

    const hbTemplate = Handlebars.compile(document.getElementById('select-ratings-filter-template').innerHTML);

    const stars = {
        "5-stars-only"   : {score: 5, suffix: _t('buyer_seller-list_filters:only-filter-suffix')},
        "4-stars-and-up" : {score: 4, suffix: _t('buyer_seller-list_filters:and-up-filter-suffix')},
        "3-stars-and-up" : {score: 3, suffix: _t('buyer_seller-list_filters:and-up-filter-suffix')},
        "2-stars-and-up" : {score: 2, suffix: _t('buyer_seller-list_filters:and-up-filter-suffix')},
        "1-stars-and-up" : {score: 1, suffix: _t('buyer_seller-list_filters:and-up-filter-suffix')},
    };

    const getHtml = (data) => {
        data.data.children = addStarsHtmlToChildren(data.data.children);
        return hbTemplate(data);
    };

    const registerListner = (eventEmitter, filterKey, group, filterPrefix) => {
        $(`#select_items_${filterKey} .filter-select-option`).off('click').on('click', function (e) {
            e.preventDefault();
            if(!$(this).hasClass("selected")){

                let prevSelectedValue = getSelectedValue(filterKey);

                setSelected($(this), filterKey, filterPrefix);
                eventEmitter.emit('filters.applied', {filter: filterKey, group: group});

                if($(this).data('filterId') === 'all'){
                    barkTrackingLogEvent(
                        'seller-list-&-profile',
                        'seller_list_filters - Filter removed',
                        {project_id: getProjectHash(), filter_name: filterKey, filter_value: prevSelectedValue}
                    );
                } else {
                    barkTrackingLogEvent(
                        'seller-list-&-profile',
                        'seller_list_filters - Filter applied',
                        {project_id: getProjectHash(), filter_name: filterKey, filter_value: $(this).data('filterId')}
                    );
                }

            }
        });

        $(`#select_selected_${filterKey}`).off('click').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(".filter-select-items").removeClass('d-block');
            if(!$(this).hasClass("disabled")){

                $(`#select_items_${filterKey}`).addClass('d-block');

                barkTrackingLogEvent(
                    'seller-list-&-profile',
                    'seller_list_filters - Filter view',
                    {project_id: getProjectHash(), filter_name: filterKey}
                );
            }
        });
    };

    const getSelectedValue = (filterKey) => {
        return $(`#select_items_${filterKey}`).find(`.selected`).data('filterId');
    };

    const disableFilter = (filterKey) => {
        $(`#select_selected_${filterKey}`).addClass('disabled');
    };

    const enableFilter = (filterKey) => {
        $(`#select_selected_${filterKey}`).removeClass('disabled');
    };


    const initFilter = (filterKey, filterPrefix) => {
        let selectedOption = $(`#select_items_${filterKey}`).find(`.selected`);
        if(!selectedOption.length){
            selectedOption = $(`#select_items_${filterKey}`).find(`[data-is-default-selected="true"]`);
        }
        setSelected(selectedOption, filterKey, filterPrefix);
    };

    const setSelected = ($option, filterKey, filterPrefix) => {
        $(`#select_items_${filterKey}`).find(`.selected`).removeClass("selected");
        $option.addClass("selected");

        let selectText = $option.data('filterId') !== 'all' ? getReviewStarsHtml($option.data('filterId')) : $option.data('filterValue');
        $(`#select_selected_${filterKey}`).empty().append(selectText);
    };

    const addStarsHtmlToChildren = (children) => {
        return children.map((child) => {
            child.starsHtml = child.filter_id !== 'all' ? getReviewStarsHtml(child.filter_id) : '';
            return child;
        });
    };

    const getReviewStarsHtml = (filterId) => {
        return `${ReviewStars().generateStars(stars[filterId].score)}<span class="ml-1 align-middle">${stars[filterId].suffix}</span>`;
    };

    const getProjectHash = () => {
        return $('#project-id').val();
    };

    return {
        getHtml,
        registerListner,
        getSelectedValue,
        disableFilter,
        enableFilter,
        initFilter,
    };
}
